<template>
<div>
    <b-table 
        responsive
        :fields="fields" 
        striped hover  
        :items="items">
        <template v-slot:cell(nombre)="data">
            <b-row>
                <b-col class="col-sm-2 d-none d-sm-block">
                    <b-img @click.prevent="itemInfo(data.item)" :src="data.item.imagen" alt="Image 1" style="cursor: pointer; max-width: 100%; max-height: 150px; object-fit: scale-down;"></b-img>
                </b-col>
                <b-col cols="12" md="9">
                    <div>
                        <a class="brown--text" @click.prevent="itemInfo(data.item)">{{data.item.nombre}} </a>
                    </div>
                    <div>
                        <b>Referencia:</b> {{data.item.codigoItem}}
                    </div>
                    <div v-if="data.item.cantidad > data.item.existencia && data.item.item_propio === 1 && opcionExistencia === 1">
                        <b-badge variant="danger">Disponible: {{data.item.existencia}}</b-badge>
                    </div>
                    <div v-if="data.item.precio_personalizado == 2">
                        <strong>DC </strong> 
                    </div>
                    <div>
                        <b-button pill variant="danger" size="sm" 
                            @click.prevent="confirmDeleteItem(data.item)">
                            <b-icon icon="trash"></b-icon>
                        </b-button>
                    </div>
                </b-col>
            </b-row>
        </template>
        <template v-slot:cell(cantidad)="data">
            <b-form-input type="number" min="1" oninput="validity.valid||(value='');" 
                v-model="data.item.cantidad" 
                @change="updateItemAmmountCart(data.item)">
            </b-form-input>
        </template>
        <template v-slot:cell(valor_real_unit)="data">
            <span class="no-wrap">$ {{numberFormat(data.item.valor_real_unit) }}</span>
        </template>
        <template v-slot:cell(porcentaje_impuesto)="data">
            {{data.item.porcentaje_impuesto}} %
        </template>
        <template v-slot:cell(subtotal_por_items)="data">
            $ {{ numberFormat(data.item.subtotal_por_items) }}
        </template>
    </b-table>
    <hr>
        <b-row align-h="between" class="px-4">
            <b-col cols="12" md="6">
                <div class="pb-4"><b>Comentario de la Orden:</b></div>
                <div>
                    <b-button variant="info" @click.prevent="$emit('open-modal-order-comment')">
                        <b-icon icon="trash"></b-icon> Añadir comentario
                    </b-button>
                </div>
                <div v-if="comentario !== null" class="pt-3">
                    <div><b>Comentario:</b></div>
                    <div>{{comentario}}</div>
                </div>
            </b-col>
            <b-col cols="12" md="4">
                <table class="table table-bordered">
                    <tbody>
                        <tr>
                            <th class="text-end">Subtotal Bruto:</th>
                            <td><b>$ {{numberFormat(datoCalculos.subtotal_bruto)}}</b></td>
                        </tr>
                        <tr v-if="datoCalculos.descuento_comercial > 0">
                            <th class="text-end">Descuento:</th>
                            <td><b>$ {{numberFormat(datoCalculos.descuento_comercial)}}</b></td>
                        </tr>
                        <tr>
                            <th class="text-end">Subtotal Neto:</th>
                            <td><b>$ {{numberFormat(datoCalculos.subtotal_neto)}}</b></td>
                        </tr>
                        <tr>
                            <th class="text-end">IVA:</th>
                            <td><b>$ {{numberFormat(datoCalculos.impuesto)}}</b></td>
                        </tr>
                        <tr>
                            <th class="text-end blue--text">Monto Total:</th>
                            <td class="blue--text"><b>$ {{numberFormat(datoCalculos.total_precio)}}</b></td>
                        </tr>
                    </tbody>
                </table>
            </b-col>
        </b-row>
        <DeleteItemModal 
            :modalDeleteItemFromCart="modalDeleteItemFromCart"
            :deleteItemDetail="deleteItemDetail"
            @close-modal="modalDeleteItemFromCart = false"
            @confirm-modal="deleteItemFromCart($event)"
            />
    </div>
</template>

<script>
import {  mapState, mapMutations } from 'vuex'
import DeleteItemModal from './DeleteItemModal.vue'
export default {
    name: "ItemsComponent",
    props: {
        items: {
            type: Array
        },
        opcionExistencia: {
            type: Number
        },
        datoCalculos: {
            type: Object
        },
        comentario: {
            type: String
        }
    },
    data(){
        return{
            fields: [
                { key: 'nombre', label: 'Item', sortable: true},
                { key: 'cantidad', label: 'Cantidad', sortable: true},
                { key: 'valor_real_unit', label: 'Vr. Unit.', sortable: true},
                { key: 'porcentaje_impuesto', label: 'Imp. %', sortable: true},
                { key: 'subtotal_por_items', label: 'Subtotal', sortable: true},
            ],
            modalDeleteItemFromCart: false,
            deleteItemDetail: {}
        }
    },
    components: {
        DeleteItemModal
    },
    computed:{
        ...mapState('auth', ['user']),
    },
    methods: {
        ...mapMutations(['setLoading']),
        confirmDeleteItem(item){
            this.modalDeleteItemFromCart = true;
            this.deleteItemDetail = item;
        },
        async deleteItemFromCart(itemId){
           this.setLoading(true)
           this.modalDeleteItemFromCart = false;
           await this.$conectar.post('/cart/delete-item-from-cart-user', {id: itemId})
           .then(() =>{
                this.$emit('get-cart-info-and-price');
           })
           .catch(e =>{
                console.log(e.response);
                this.setLoading(false)
           })
           this.setLoading(false)
        },
        async updateItemAmmountCart(item){
            this.setLoading(true)
            let id = item.id;
            let cantidad = item.cantidad;
            let referencia = item.codigoItem;
            let actualizar = {id, cantidad, referencia};
            await this.$conectar.post('articulos/update-item-cart', actualizar)
            .then(response => {
                if(response.data.error == false){
                    this.$emit('get-cart-info-and-price');
                }else{
                    this.$root.$bvToast.toast(response.data.mensaje, {
                        title: "Respuesta del servidor",
                        variant: "warning",
                        solid: true
                    })
                    this.$emit('get-cart-info-and-price');
                }
            })
            .catch(e => {
                console.log(e.response);
                this.$bvToast.toast('Parece que hubo un error en el servidor', {
                    title: "Respuesta del servidor",
                    variant: "danger",
                    solid: true
                })
                this.$emit('get-cart-info-and-price');
            })
            this.setLoading(false)
        },
        itemInfo(datos){
            if(datos.item_propio === 0){
                this.$router.push({ name: 'ItemDetail', params:{ referencia: datos.codigoItem} });
            }else if(datos.item_propio === 1){
                this.$router.push({ name: 'itemEmpresaDetail', params:{ codigo: datos.codigoItem} });
            }
        },
    }
};

</script>
<style scoped>

</style>